import React from 'react'
import { Fieldset, Field, ButtonPrimary, SpacerVertical } from '@klarna/bubble-ui'
import DialogUnwrapped from 'common/components/dialog-unwrapped'
import CenteredContent from 'common/components/centered-content'
import IssuerLogo from 'common/components/issuer-logo'
import useTranslate from 'common/hooks/use-translate'
import useForm from 'common/hooks/use-form'
import SubmitOnEnter from './submit-on-enter'
import fields from '../fields'

function validate(value) {
  if (value.length === 0) {
    return 'eligibility.pre_assessment.affordability_form.required_field'
  }

  if (!/^\d+$/.test(value)) {
    return 'eligibility.pre_assessment.affordability_form.invalid_number'
  }

  return undefined
}

function AffordabilityForm({
  customerData,
  onSubmit,
  onClose
}: {
  customerData: any
  onSubmit: Function
  onClose: Function
}) {
  const translate = useTranslate()
  const { field, values, hasError } = useForm(() =>
    Object.keys(customerData).reduce(
      (acc, key) => ({
        ...acc,
        [key]:
          customerData[key] && fields[key] && fields[key].type === 'IMPLICIT_DECIMAL'
            ? parseInt(customerData[key], 10) / 100
            : customerData[key]
      }),
      {}
    )
  )

  function submitValues() {
    onSubmit(values)
  }

  return (
    <DialogUnwrapped
      id="affordability-form-dialog"
      title={<IssuerLogo asDialogTitle />}
      onClose={onClose}
      footer={[
        {
          Component: ButtonPrimary,
          props: {
            id: 'submit-button',
            children: translate('eligibility.pre_assessment.affordability_form.continue'),
            disabled: hasError,
            onClick: submitValues
          }
        }
      ]}
    >
      <CenteredContent
        title={translate('eligibility.pre_assessment.affordability_form.title')}
        summary={translate('eligibility.pre_assessment.affordability_form.summary')}
      />
      <SpacerVertical spaceToken="space.400" />
      <SpacerVertical spaceToken="space.50" />
      <SubmitOnEnter onSubmit={hasError ? null : submitValues}>
        <Fieldset
          fields={Object.keys(customerData).map(key => ({
            Component: Field,
            size: 1,
            props: {
              ...field(key, validate),
              label: translate(fields[key].label),
              name: fields[key].name,
              type: 'number'
            }
          }))}
        />
      </SubmitOnEnter>
    </DialogUnwrapped>
  )
}

export default AffordabilityForm
